<template>
    <div assignment-role>
        <el-card class="filter-card">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-content" style="height: 40px; background-color: white;line-height: 40px; border-radius: 4px;text-indent: 10px;">
                    <el-breadcrumb-item to="/sys/role">角色管理</el-breadcrumb-item>
                    <el-breadcrumb-item>用户分配</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-table
                :data="userList"
                stripe
                ref="multipleTableClinicRoom"
                :header-cell-style="{background: '#eef1f6', color: '#606266', fontWeight: 'bolder'}"
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="realName"
                    label="登陆名称"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="userMobile"
                    label="手机"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="userEmail"
                    label="邮箱"
                    align="center">
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.createdTime | moment }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                class="pagination"
                @current-change="changePage"
                layout="prev, pager, next"
                :total="totalCount">
            </el-pagination>
            <div class="save-btn">
                <el-button size="small" type="success" icon="el-icon-check" @click="saveInfo('ruleForm')">保存</el-button>
                <el-button size="small" type="danger" icon="el-icon-close" @click="$router.back()">关闭</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import { assignmentUser } from '@/api/roleMange';
import { getUserData } from '@/api/usermange';
export default {
    name: "AssignmentRole",
    data(){
        return {
            params: {
                pageNo: 1,
                pageSize: 10,
                companyId:  this.$route.query.companyId,
                userCode: '',
            },
            userIds: this.$route.query.userIds,
            userList: [],
            totalCount: null,
            multipleSelection: [],
            query: {
                roleId: this.$route.query.roleId,
                userIds: []
            }
        }
    },
    created() {
        this.getUserList()
    },
    methods: {
        async getUserList(){
            this.params.companyId = Number(this.params.companyId)
            this.params.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            const res = await getUserData(this.params);
            if(res.code === '200'){
                this.userList = res.data.list
                this.userList.forEach((item,index) => {
                    this.userIds.forEach((value, key) => {
                        if(value.indexOf(item.userId) > -1){
                            this.$nextTick(() => {
                                this.$refs.multipleTableClinicRoom.toggleRowSelection(this.userList[index], true)
                            })
                        }
                    })
                })
                this.totalCount = res.data.total
            }
        },
        // table表格数据选择
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async saveInfo(){
            this.multipleSelection.forEach(item => {
                this.query.userIds.push(item.userId)
            })
            const res = await assignmentUser(this.query);
            if(res.code === '200'){
                this.$message.success('修改成功')
                this.$router.back()
            }else{
                this.$message.error(res.msg)
            }
        },
        changePage(e){
            this.params.pageNo = e;
            this.getUserList()
        }
    }
}
</script>

<style scoped>
::v-deep .el-card__header{
    padding: 10px 20px;
}
</style>
<style scoped lang="scss">
.pagination{
    text-align: right;
    margin: 20px 0 0;
}
.save-btn {
    margin-top: 30px;
    text-align: center;
}
</style>
